<div class="calendar" [class.loading]="calendarLoading" [class.collapsed]="!isCalendarExpanded" [class.has-events]="calendarLoaded && calendar && calendar.length > 0">
  <div class="calendar-header" (click)="toggleMobileExpand()">
    <button mat-icon-button class="desktop-collapse-btn" (click)="toggleCalendar(); $event.stopPropagation()">
      <mat-icon>calendar_today</mat-icon>
    </button>
    <div class="expandable-content">
      <h3>Calendar Events</h3>
      <div class="header-actions">
        @if (hasGoogleAccess == false || hasMicrosoftAccess == false) {
          <button mat-icon-button (click)="showSettings = !showSettings; $event.stopPropagation()">
            <mat-icon>settings</mat-icon>
          </button>
        }
        <mat-icon class="mobile-expand-btn">{{ isMobileExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
      </div>
    </div>
  </div>

  <!-- Collapsed State Placeholders -->
  @if (!isCalendarExpanded && calendarLoaded && calendar && calendar.length > 0) {
    <div class="collapsed-placeholders" (click)="toggleCalendar()">
      @for (group of groupedCalendarEvents | keyvalue; track group.key) {
        <div class="placeholder-group">
          <div class="source-icon" [class.google-icon]="group.key === 'google'" [class.microsoft-icon]="group.key === 'microsoft'"></div>
          @for (item of [1,2,3]; track item) {
            <div class="placeholder-item"></div>
          }
        </div>
      }
    </div>
  }

  <div class="calendar-content" [class.mobile-collapsed]="!isMobileExpanded">
    <div class="expandable-content">
      <div class="collapsed-icon" *ngIf="!isCalendarExpanded">
        <mat-icon>calendar_today</mat-icon>
      </div>
      @if ((!hasGoogleAccess && !hasMicrosoftAccess) || showSettings) {
        <div class="connect-calendar">
          @if (!hasGoogleAccess) {
            <button 
              mat-raised-button 
              class="connect-btn" 
              [disabled]="isConnectingGoogle"
              (click)="requestCalendarAccess()">
              @if (isConnectingGoogle) {
                <mat-spinner diameter="18"></mat-spinner>
                <span>&nbsp;Connecting...</span>
              } @else {
                <mat-icon>calendar_today</mat-icon>
                <span>&nbsp;Google</span>
              }
            </button>
          }
          @if (!hasMicrosoftAccess) {
            <button 
              mat-raised-button 
              class="connect-btn" 
              [disabled]="isConnectingMicrosoft"
              (click)="requestMicrosoftCalendarAccess()">
              @if (isConnectingMicrosoft) {
                <mat-spinner diameter="18"></mat-spinner>
                <span>&nbsp;Connecting...</span>
              } @else {
                <mat-icon>calendar_today</mat-icon>
                <span>&nbsp;Microsoft</span>
              }
            </button>
          }
        </div>
      }

      @if ((hasGoogleAccess || hasMicrosoftAccess) && !showSettings) {
        @if (calendarLoading) {
          <div class="loading">
            <mat-spinner diameter="24"></mat-spinner>
            <span>Loading calendar...</span>
          </div>
        } @else {
          @if (calendarLoaded && (!calendar || calendar.length === 0)) {
            <div class="no-events">
              No events found for this day
            </div>
          }

          @if (calendarLoaded && calendar && calendar.length > 0) {
            @for (group of groupedCalendarEvents | keyvalue; track group.key) {
              <div class="calendar-group" [class.loading]="calendarLoading">
                <div class="group-header">
                  <div class="source-icon" [class.google-icon]="group.key === 'google'" [class.microsoft-icon]="group.key === 'microsoft'"></div>
                  <div>{{ group.key }}</div>
                  <div>{{ (group.value[0]?.organizer || 'Unknown') }}</div>
                </div>

                @for (item of group.value; track item.id) {
                  <div
                    class="calendar-item"
                    [class.selected]="item.id === selectedCalenderId"
                    (click)="loadFromCalendar(item)"
                    >
                    <div class="content">
                      <div class="title-row">
                        <div class="heading">
                          {{ item.title || 'Untitled Event' }}
                        </div>
                        <div class="checkbox">
                          <input
                            type="checkbox"
                            [checked]="item.checked"
                            (click)="$event.stopPropagation()"
                            (change)="checkBoxChanged($event, item)"
                          >
                        </div>
                      </div>
                      <div class="time-info">
                        <div class="time">
                          {{ item.start.dateTime | firebaseDate | date:'shortTime' }} -
                          {{ item.end.dateTime | firebaseDate | date:'shortTime' }}
                        </div>
                        <div class="total">
                          {{ calculateTimeDifferenceDates(
                            item.start.dateTime,
                            item.end.dateTime
                          ) }}
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            }
          }
        }
      }
    </div>
  </div>
</div> 